import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreateDCompany from "./CreateDCompany";
import EditDCompany from "./EditDCompany";
import DeleteDCompany from "./DeleteDCompany";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { useDCompaniesDataViewLogic } from "./hooks/useDCompaniesDataViewLogic";
import { Navigate } from "react-router-dom";


const DCompaniesDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent,
    apiTotalRecords
  } = useDCompaniesDataViewLogic();

  const addDCompanyButton: React.FC = () => {
    return (
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέα Θυγατρική`)}
      </Button>
    )
  };

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} showDetails={selectedRowsOfTable.length > 0} />
  );

  return (
    <>
        {loadingDone && (
          <>
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                showNumberOfRows={true}
                rowSelection={true}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No DCompanies yet"
                isChangeOrderOrVisibilityEnable={false}
                ButtonsAreaLeft={ActionButtons}
                ButtonsAreaRight={addDCompanyButton}
                hiddenColumnsForUser={["deleted","filepath","hub_Type","anet_Voice","comments","physical_IF_ID","logical_IF_ID", "id"]}
                textPosition="center"
                maxHeight="33rem"
                numberOfRows={apiTotalRecords}
                numberOfRowsTitle="θυγατρικές"
            />
          </>
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}
          size="md"  
          >
            {modalEvent.action === "create" && <CreateDCompany handleCloseModal={closeActionModal}/> }
            {modalEvent.action === "edit" && <EditDCompany handleCloseModal={closeActionModal} dCompanyId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            {modalEvent.action === "delete" && <DeleteDCompany handleCloseModal={closeActionModal} dCompanyId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {modalEvent.action === "showDetails" && 
          <Navigate to={`/configuration/unitconfiguration/detailspage/DCompanies/unittype/${modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1}/unitid`} />
        }

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default DCompaniesDataView;

